import { useState } from "react";
import InvestmentWalletLine from "./InvestmentWalletLine";
import { useTranslation } from "react-i18next";
import { ListItem, Box, Typography, Collapse } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

export default function InvestmentChildrenGroup({ type, wallets, period }) {
	const userCurrency = localStorage.getItem("userCurrency");
	const { t } = useTranslation();
	const [isUnbudgetedExpanded, setIsUnbudgetedExpanded] = useState(false);

	const budgetedWallets = wallets.filter((wallet) => wallet.budget > 0);
	const unBudgetedWallets = wallets.filter((wallet) => wallet.budget <= 0);
	const unBudgetedWalletsTransactionSum = unBudgetedWallets.reduce(
		(sum, wallet) => sum + wallet.transactionsSum,
		0,
	);

	const expandStyles = {
		width: "20px",
		verticalAlign: "middle",
		mr: 0.5,
	};

	return (
		<>
			{budgetedWallets.map((wallet) => (
				<InvestmentWalletLine
					key={wallet.walletId}
					wallet={wallet}
					type={type}
					period={period}
				/>
			))}
			<ListItem
				sx={{
					pl: 5,
					py: 0,
					display: "flex",
					justifyContent: "space-between",
					opacity: 0.5,
					fontStyle: "italic",
				}}
			>
				{unBudgetedWallets.length !== 0 && (
					<>
						<Box
							onClick={() =>
								setIsUnbudgetedExpanded((prev) => !prev)
							}
							sx={{
								cursor: "pointer",
								display: "flex",
							}}
						>
							{isUnbudgetedExpanded ? (
								<>
									<ExpandLess sx={expandStyles} />
									<span>{t("hideUnbudgeted")}</span>
								</>
							) : (
								<>
									<ExpandMore sx={expandStyles} />
									<span>{t("showUnbudgeted")}</span>
								</>
							)}
						</Box>
						<Box sx={{ display: "flex", mr: 0.5 }}>
							<Typography variant="body1">
								{Math.abs(unBudgetedWalletsTransactionSum)
									.toFixed(2)
									.toLocaleString()}{" "}
								{userCurrency}
							</Typography>
							<Typography
								variant="body1"
								sx={{
									mx: 0.5,
								}}
							>
								{"/"}
							</Typography>
							<Typography variant="body1">
								{Math.abs(0).toFixed(2).toLocaleString()}{" "}
								{userCurrency}
							</Typography>
						</Box>
					</>
				)}
			</ListItem>
			<Collapse in={isUnbudgetedExpanded}>
				{unBudgetedWallets.map((wallet) => (
					<InvestmentWalletLine
						key={wallet.walletId}
						wallet={wallet}
						type={type}
						period={period}
					/>
				))}
			</Collapse>
		</>
	);
}
